// Runtime configuration. Everything the UI needs from its host environment is
// read here so the rest of the code stays host-agnostic.

const ACCESS_TOKEN_STORAGE_KEY = "mandoob:accessToken";

function trimTrailingSlash(value: string): string {
  return value.endsWith("/") ? value.slice(0, -1) : value;
}

export const appConfig = {
  // Prefix for every REST call and the socket.io handshake. Empty means same
  // origin (the vite dev server proxies /api and /socket.io to the backend).
  apiBaseUrl: trimTrailingSlash(import.meta.env.VITE_API_BASE_URL ?? ""),
  // Bawabah application id for the hosted-login redirect.
  bawabahAppId: import.meta.env.VITE_BAWABAH_APP_ID ?? "",
  // The router and public assets live under vite's `base`.
  routerBasePath: trimTrailingSlash(import.meta.env.BASE_URL) || "/",
  assetsBasePath: trimTrailingSlash(import.meta.env.BASE_URL),
  // Google Maps JS/Places/Static Maps key. Empty disables the location picker
  // and the static map preview in location bubbles.
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API ?? "",
  // OneSignal app id (same id for iOS, Android and web). Empty disables push
  // entirely and leaves only the in-app local notifications.
  oneSignalAppId: import.meta.env.VITE_ONESIGNAL_APP_ID ?? "",
} as const;

export function apiUrl(path: string): string {
  return `${appConfig.apiBaseUrl}${path}`;
}

export function assetUrl(path: string): string {
  return `${appConfig.assetsBasePath}${path}`;
}

export function getAccessToken(): string | null {
  try {
    return localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setAccessToken(token: string | null): void {
  try {
    if (token) localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, token);
    else localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
  } catch {
    // storage unavailable — token stays in memory for this page only
  }
}

export function clearAccessToken(): void {
  setAccessToken(null);
}
